import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ImageMessage, TextMessage } from '../../common/types';
import { LazyLoadImage, ScrollPosition } from 'react-lazy-load-image-component';

import 'react-lazy-load-image-component/src/effects/blur.css';

export type RenderedImageMessageProps = {
  message: ImageMessage;
  index: number;
  length: number;
  scrollPosition?: ScrollPosition;
  onLoad?: () => void;
};

export default function RenderedImageMessage(props: RenderedImageMessageProps) {
  const { message, index, length } = props;

  const textContent = (
    <div className="chat-image">
      <img
        className="rounded-lg"
        height="auto"
        src={message.url}
        alt={message.caption}
        width="100%"
        onLoad={props.onLoad}
      />
      {/* <LazyLoadImage
        className='rounded-lg'
        // alt={caption}
        effect="blur"
        height="auto"
        placeholder={
          <img
            // alt={caption}
            height="auto"
            src="https://cdn.aiescape.io/loading.png"
            // title={caption}
            width="100%"
          />
        }
        // scrollPosition={props.scrollPosition}
        src={message.url}
        threshold={500}
        // title={caption}
        width="100%"
        onLoad={props.onLoad}
      /> */}
    </div>
  );

  return textContent;
}
